<template>
  <UpgradeAccountModal :upgrade-type="CREATE_ACCOUNT_MODAL">
    <template v-slot:reason-heading>
      This feature is for members&nbsp;only
    </template>
    <template v-slot:main-message>
      Unlock all of our most powerful tools and features when you become a StockCharts&nbsp;Member
    </template>
    <template v-slot:sub-message>
      <p class="upgrade-account-message">
        Create bigger, better, more advanced charts and save them to your account for easy access across all your devices.
        Run custom scans to find new trade targets or investment opportunities, set automatic alerts for your unique technical criteria, and much&nbsp;more.
      </p>
      <p class="upgrade-account-message-bold">
        Start your free 1-month trial in less&nbsp;than&nbsp;60&nbsp;seconds.
      </p>
    </template>
    <template v-slot:button-group>
      <a
        class="sc3-button sc3-button-light-green sc3-button-extra-large"
        href="/checkout/freetrial/"
        target="_blank"
      >
        <i class="fas fa-fw fa-check-circle"></i>
        &nbsp;&nbsp;Free&nbsp;1-Month&nbsp;Trial
      </a>
      <a
        class="sc3-button-link"
        href="/"
      >Learn More</a>
      <br />
      <button
        type="button"
        class="sc3-button-link close-button"
        @click="closeModal()"
      >
        No Thanks
      </button>
    </template>
  </UpgradeAccountModal>
</template>

<script lang="ts" setup>
  import { useModals } from '@/composables/useModals';
  import UpgradeAccountModal from '@/components/modals/UpgradeAccountModal.vue';

  const { CREATE_ACCOUNT_MODAL, closeModal } = useModals();
</script>
